module.exports = __webpack_public_path__ + "static/media/ap.538074ca.png";